<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Aplikimi per partner: {{ partnerRequestDetails.is_business === 0 ? partnerRequestDetails.first_name + ' '+ partnerRequestDetails.last_name : partnerRequestDetails.company_name }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <form>
            <div class="col-12">
              <div class="white-background mb-30">
                <div class="form-group">

                  <label>Të dhënat e aplikuesit</label>

                  <table class="tab-style table">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Emri & Mbiemri / Kompania</td>
                      <td>{{ partnerRequestDetails.is_business === 0 ? partnerRequestDetails.first_name + ' '+ partnerRequestDetails.last_name : partnerRequestDetails.company_name }}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ partnerRequestDetails.email }}</td>
                    </tr>
                    <tr>
                      <td>Telefoni</td>
                      <td>{{ partnerRequestDetails.phone }}</td>
                    </tr>
                    <tr>
                      <td>ID Personale / Numri biznesit</td>
                      <td>{{ partnerRequestDetails.is_business === 0 ? partnerRequestDetails.personal_id : partnerRequestDetails.business_number }}</td>
                    </tr>
                    <tr>
                      <td>Adresa</td>
                      <td>{{ partnerRequestDetails.address }}</td>
                    </tr>
                    <tr>
                      <td>Lloji i Aplikimit</td>
                      <td>{{ partnerRequestDetails.is_business === 0 ? 'Individual' : 'Kompani' }}</td>
                    </tr>
                    <tr>
                      <td>Zona operimit</td>
                      <td>{{ partnerRequestDetails.operation_zone }}</td>
                    </tr>
                  </table>
                  <hr/>
                  <label>Foto te ID / certifikates se biznesit</label>
                  <div class="d-flex mr-2 mt-3 justify-content-center mb-3" >
                    <div v-for="img in partnerRequestDetails.photos" :key="img.id">
                      <a :href="`${back_end_url + img.photo}`" target="_blank"><img width="150px" height="150px" class="mr-3" :src="`${back_end_url + img.photo}`" alt=""/></a>
                    </div>
                  </div>
                  <label class="mt-3">Statusi i Kerkeses</label>
                  <table class="tab-style table">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Statusi</td>
                      <td>{{ partnerRequestDetails.approved === 0 ? 'Pa aprovuar' : 'I aprovuar' }}</td>
                    </tr>
                  </table>
                  <label>Të dhënat e veturës</label>
                  <div v-for="(vehicle, index) in partnerRequestDetails.vehicles" :key="index">
                  <table class="tab-style table" >
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td><strong>Vetura Nr. {{ index + 1 }}</strong></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Model</td>
                      <td>{{ vehicle.vehicle_model }}</td>
                    </tr>
                    <tr>
                      <td>Targat</td>
                      <td>{{ vehicle.plate_number }}</td>
                    </tr>
                    <tr>
                      <td>Viti i regjistrimit</td>
                      <td>{{ vehicle.vehicle_year }}</td>
                    </tr>
                  </table>
                    <hr/>
                    <label>Foto te automjetit</label>
                    <div class="d-flex mr-2 mt-3 justify-content-center mb-3" >
                      <div v-for="img in vehicle.vehicle_photos" :key="img.id">
                        <a :href="`${back_end_url + img.vehicle_photo}`" target="_blank"><img width="150px" height="150px" class="mr-3" :src="`${back_end_url + img.vehicle_photo}`" alt=""/></a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex flex-column flex-md-row justify-content-between confirmation">
                <router-link class="mb-2 mb-md-0" tag="button" to="/admin/partner/requests">KTHEHU</router-link>
                <button v-if="partnerRequestDetails.approved !== 1" class="mb-2 mb-md-0 btn-custom-danger" @click="rejectPartnerRequest" >refuzo kerkesen</button>
                <button v-if="partnerRequestDetails.approved !== 1" class="mb-2 mb-md-0" @click="approvePartnerRequest">konfirmo kerkesen</button>
                <button v-if="partnerRequestDetails.approved === 1" class="mb-2 mb-md-0 btn-custom-danger" @click="deletePartner">Fshij Partnerin</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>

</template>

<style src="@/assets/admin/css/main.css">
</style>
<script>


import AdminSidebar from "@/components/admin/AdminSidebar";
import {mapGetters} from "vuex";

export default {
  name: "AdminPartnerRequestDetail",
  components: {
    AdminSidebar,
  },
  data() {
    return {
      back_end_url: process.env.VUE_APP_BACKEND_ROOT_API + '/'
    }
  },
  methods: {
    rejectPartnerRequest(e) {
      let answer = confirm('A jeni i sigurte qe doni te refuzoni kerkesen?!');
      e.preventDefault();
      if(answer === true) {
        this.$store.dispatch("partnersForm/rejectPartnerRequest", this.$route.params.id);
      }
    },
    approvePartnerRequest(e) {
      let answer = confirm('A jeni i sigurte qe doni te konfirmoni kerkesen?!');
      e.preventDefault();
      if(answer === true) {
        this.$store.dispatch("partnersForm/approvePartnerRequest", this.$route.params.id);
      }
    },
    deletePartner(e) {
      let answer = confirm('A jeni i sigurte qe doni te fshini Partnerin?!');
      e.preventDefault();
      if(answer === true) {
        this.$store.dispatch("partnersForm/deletePartner", this.$route.params.id);
      }
    }
  },
  beforeMount() {
    this.$store.dispatch(
        "partnersForm/getPartnerRequestDetail",
        this.$route.params.id
    );
  },
  computed: {
    ...mapGetters({
      partnerRequestDetails: "partnersForm/partner_request_details",
    })
  },
}
</script>

<style scoped>

</style>